module.exports = __webpack_public_path__ + "media/images/prediction/bnr_prediction_nagai_extra-d8d74232c762e19292ecb3c7a0df7927.jpg";